import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { setProfileStatus } from "../../actions/profile";

import GreenLogo from "../layout/Innovators/GreenLogo";
import RedLogo from "../layout/Mentors/RedLogo";
import BlueLogo from "../layout/Employers/BlueLogo";
import LoggedOutNav from "../layout/IME/LoggedOutNav";
import GreenSpinner from "../../img/Green_Spinner.gif";
import RedSpinner from "../../img/Red_Spinner.gif";
import BlueSpinner from "../../img/Blue_Spinner.gif";

const Setup = ({
  auth: { user, isAuthenticated },
  setProfileStatus,
  profile: {
    profilestatus: { channelid },
  },
}) => {
  const [isCurrent, setCurrent] = useState({ public: true, private: false });

  // if (channelid && channelid === user.channelid) {
  //   return <Redirect to={`/${channelid}/setupprofile`} />;
  // }

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {!isAuthenticated && <LoggedOutNav />}
      {user.role === "innovator" && (
        <div className="setup-container">
          <div className="initialize-title">
            <div className="flex">
              <div className="logo-setup">
                <GreenLogo />
              </div>
              {!isAuthenticated && (
                <h1 className="setup-heading green">Not Authorized!</h1>
              )}
              {isAuthenticated && (
                <h1 className="setup-heading green">
                  Welcome to ime, {user && user.firstname}!
                </h1>
              )}
            </div>
            {isAuthenticated && (
              <p className="lead">Let's get your profile setup</p>
            )}
          </div>
          <div className="setup-container-alt">
            {isAuthenticated && (
              <div className="section-info">
                <p className="setup-info">Chooose your profile type:</p>
                <p
                  className="setup-next white"
                  onClick={() => setProfileStatus({ isCurrent })}
                >
                  Next <i className="fas fa-arrow-circle-right green mx-5"></i>
                </p>
              </div>
            )}
            {!isAuthenticated && (
              <div className="not-authorized">
                <img src={GreenSpinner} />
              </div>
            )}
            {isAuthenticated && (
              <div>
                <table>
                  <thead>
                    <tr>
                      <th></th>
                      <th>
                        <input
                          className="select-choice-button"
                          type="radio"
                          checked={isCurrent.public}
                          value="public"
                          id="public"
                          onChange={(e) =>
                            setCurrent({
                              ...isCurrent,
                              public: e.target.checked,
                              private: false,
                            })
                          }
                          name="public"
                        />
                        <label className="mx-10 large-font" htmlFor="public">
                          Public
                        </label>
                      </th>
                      <th>
                        <input
                          className="select-choice-button"
                          type="radio"
                          checked={isCurrent.private}
                          value="private"
                          id="private"
                          onChange={(e) =>
                            setCurrent({
                              ...isCurrent,
                              private: e.target.checked,
                              public: false,
                            })
                          }
                          name="private"
                        />
                        <label className="mx-10 large-font" htmlFor="private">
                          Private
                        </label>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="green">Apply for jobs</td>
                      <td className="green">
                        <i className="far fa-check-circle green "></i>
                      </td>
                      <td className="green">
                        <i className="far fa-check-circle green"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="green">Chat in live streams</td>
                      <td className="green">
                        <i className="far fa-check-circle green"></i>
                      </td>
                      <td className="green">
                        <i className="far fa-check-circle green"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="green">Participate in live discussions</td>
                      <td className="green">
                        <i className="far fa-check-circle green"></i>
                      </td>
                      <td className="green">
                        <i className="far fa-check-circle green"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="green">Publish articles</td>
                      <td className="green">
                        <i className="far fa-check-circle green"></i>
                      </td>
                      <td className="green">
                        <i className="far fa-check-circle green"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="green">Anyone can view your profile</td>
                      <td className="green">
                        <i className="far fa-check-circle green"></i>
                      </td>
                      <td className="green">
                        <i className="far fa-times-circle red"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="green">Anyone can message you</td>
                      <td className="green">
                        <i className="far fa-check-circle green"></i>
                      </td>
                      <td className="green">
                        <i className="far fa-times-circle red"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="green">Anyone can view your articles</td>
                      <td className="green">
                        <i className="far fa-check-circle green"></i>
                      </td>
                      <td className="green">
                        <i className="far fa-times-circle red"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="green">Friends</td>
                      <td className="green">
                        <i className="far fa-check-circle green"></i>
                      </td>
                      <td className="green">
                        <i className="far fa-check-circle green"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="green">Followers</td>
                      <td className="green">
                        <i className="far fa-check-circle green"></i>
                      </td>
                      <td className="green">
                        <i className="far fa-check-circle green"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="green">Subscribe to Mentors</td>
                      <td className="green">
                        <i className="far fa-check-circle green"></i>
                      </td>
                      <td className="green">
                        <i className="far fa-check-circle green"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="green">Purchase courses</td>
                      <td className="green">
                        <i className="far fa-check-circle green"></i>
                      </td>
                      <td className="green">
                        <i className="far fa-check-circle green"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="green">Follow Employers</td>
                      <td className="green">
                        <i className="far fa-check-circle green"></i>
                      </td>
                      <td className="green">
                        <i className="far fa-check-circle green"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}
      {user.role === "mentor" && (
        <div className="setup-container">
          <div className="initialize-title">
            <div className="flex">
              <div className="logo-setup">
                <RedLogo />
              </div>
              {!isAuthenticated && (
                <h1 className="setup-heading red">Not Authorized!</h1>
              )}
              {isAuthenticated && (
                <h1 className="setup-heading red">
                  Welcome to ime, {user && user.firstname}!
                </h1>
              )}
            </div>
            {isAuthenticated && (
              <p className="lead">Let's get your profile setup</p>
            )}
          </div>
          <div className="setup-container-alt">
            {isAuthenticated && (
              <div className="section-info">
                <p className="setup-info">Chooose your profile type:</p>
                <p
                  className="setup-next white"
                  onClick={() => setProfileStatus({ isCurrent })}
                >
                  Next <i className="fas fa-arrow-circle-right red mx-5"></i>
                </p>
              </div>
            )}
            {!isAuthenticated && (
              <div className="not-authorized">
                <img src={RedSpinner} />
              </div>
            )}
            {isAuthenticated && (
              <div>
                <table>
                  <thead>
                    <tr>
                      <th></th>
                      <th>
                        <input
                          className="select-choice-button"
                          type="radio"
                          checked={isCurrent.public}
                          value="public"
                          id="public"
                          onChange={(e) =>
                            setCurrent({
                              ...isCurrent,
                              public: e.target.checked,
                              private: false,
                            })
                          }
                          name="public"
                        />
                        <label className="mx-10 large-font" htmlFor="public">
                          Public
                        </label>
                      </th>
                      <th>
                        <input
                          className="select-choice-button"
                          type="radio"
                          checked={isCurrent.private}
                          value="private"
                          id="private"
                          onChange={(e) =>
                            setCurrent({
                              ...isCurrent,
                              private: e.target.checked,
                              public: false,
                            })
                          }
                          name="private"
                        />
                        <label className="mx-10 large-font" htmlFor="private">
                          Private
                        </label>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="red">Chat in live streams</td>
                      <td className="red">
                        <i className="far fa-check-circle red"></i>
                      </td>
                      <td className="red">
                        <i className="far fa-check-circle red"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="red">Anyone can view your profile</td>
                      <td className="red">
                        <i className="far fa-check-circle red"></i>
                      </td>
                      <td className="red">
                        <i className="far fa-times-circle red"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="red">Anyone can message you</td>
                      <td className="red">
                        <i className="far fa-check-circle red"></i>
                      </td>
                      <td className="red">
                        <i className="far fa-times-circle red"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="red">Friends</td>
                      <td className="red">
                        <i className="far fa-check-circle red"></i>
                      </td>
                      <td className="red">
                        <i className="far fa-check-circle red"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="red">Followers</td>
                      <td className="red">
                        <i className="far fa-check-circle red"></i>
                      </td>
                      <td className="red">
                        <i className="far fa-check-circle red"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="red">Subscribe to Mentors</td>
                      <td className="red">
                        <i className="far fa-check-circle red"></i>
                      </td>
                      <td className="red">
                        <i className="far fa-check-circle red"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="red">Purchase courses</td>
                      <td className="red">
                        <i className="far fa-check-circle red"></i>
                      </td>
                      <td className="red">
                        <i className="far fa-check-circle red"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="red">Follow Employers</td>
                      <td className="red">
                        <i className="far fa-check-circle red"></i>
                      </td>
                      <td className="red">
                        <i className="far fa-check-circle red"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}
      {user.role === "employer" && (
        <div className="setup-container">
          <div className="initialize-title">
            <div className="flex">
              <div className="logo-setup">
                <BlueLogo />
              </div>
              {!isAuthenticated && (
                <h1 className="setup-heading blue">Not Authorized!</h1>
              )}
              {isAuthenticated && (
                <h1 className="setup-heading blue">
                  Welcome to ime, {user && user.firstname}!
                </h1>
              )}
            </div>
            {isAuthenticated && (
              <p className="lead">Let's get your profile setup</p>
            )}
          </div>
          <div className="setup-container-alt">
            {isAuthenticated && (
              <div className="section-info">
                <p className="setup-info">Chooose your profile type:</p>
                <p
                  className="setup-next white"
                  onClick={() => setProfileStatus({ isCurrent })}
                >
                  Next <i className="fas fa-arrow-circle-right blue mx-5"></i>
                </p>
              </div>
            )}
            {!isAuthenticated && (
              <div className="not-authorized">
                <img src={BlueSpinner} />
              </div>
            )}
            {isAuthenticated && (
              <div>
                <table>
                  <thead>
                    <tr>
                      <th></th>
                      <th>
                        <input
                          className="select-choice-button"
                          type="radio"
                          checked={isCurrent.public}
                          value="public"
                          id="public"
                          onChange={(e) =>
                            setCurrent({
                              ...isCurrent,
                              public: e.target.checked,
                              private: false,
                            })
                          }
                          name="public"
                        />
                        <label className="mx-10 large-font" htmlFor="public">
                          Public
                        </label>
                      </th>
                      <th>
                        <input
                          className="select-choice-button"
                          type="radio"
                          checked={isCurrent.private}
                          value="private"
                          id="private"
                          onChange={(e) =>
                            setCurrent({
                              ...isCurrent,
                              private: e.target.checked,
                              public: false,
                            })
                          }
                          name="private"
                        />
                        <label className="mx-10 large-font" htmlFor="private">
                          Private
                        </label>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="blue">Chat in live streams</td>
                      <td className="blue">
                        <i className="far fa-check-circle blue"></i>
                      </td>
                      <td className="blue">
                        <i className="far fa-check-circle blue"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="blue">Anyone can view your profile</td>
                      <td className="blue">
                        <i className="far fa-check-circle blue"></i>
                      </td>
                      <td className="blue">
                        <i className="far fa-times-circle blue"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="blue">Anyone can message you</td>
                      <td className="blue">
                        <i className="far fa-check-circle blue"></i>
                      </td>
                      <td className="blue">
                        <i className="far fa-times-circle blue"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="blue">Friends</td>
                      <td className="blue">
                        <i className="far fa-check-circle blue"></i>
                      </td>
                      <td className="blue">
                        <i className="far fa-check-circle blue"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="blue">Followers</td>
                      <td className="blue">
                        <i className="far fa-check-circle blue"></i>
                      </td>
                      <td className="blue">
                        <i className="far fa-check-circle blue"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="blue">Subscribe to Mentors</td>
                      <td className="blue">
                        <i className="far fa-check-circle blue"></i>
                      </td>
                      <td className="blue">
                        <i className="far fa-check-circle blue"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="blue">Purchase courses</td>
                      <td className="blue">
                        <i className="far fa-check-circle blue"></i>
                      </td>
                      <td className="blue">
                        <i className="far fa-check-circle blue"></i>
                      </td>
                    </tr>
                    <tr>
                      <td className="blue">Follow Employers</td>
                      <td className="blue">
                        <i className="far fa-check-circle blue"></i>
                      </td>
                      <td className="blue">
                        <i className="far fa-check-circle blue"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}
    </Fragment>
  );
};

Setup.propTypes = {
  auth: PropTypes.object.isRequired,
  setProfileStatus: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.isAuthenticated,
  profile: state.profile,
});

export default connect(mapStateToProps, { setProfileStatus })(Setup);
